import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

const Documents = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { documentsList, searchText ,apiCall} = props;

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Documents", obj?.Title, obj?.AssetUrl);
    }
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Documents</div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Document ?
                <AxiosIndicatorRunTimeLoader />
                : <>
                    {documentsList.length > 0 ?
                        <>
                            <div className='search-product-list'>
                                <div className="search-documents-list">
                                    {documentsList.map((v, i) => (
                                        <React.Fragment key={i}>
                                            {i < 5 &&
                                                <a onClick={() => typeHeadSearchEvent(v)} href={v.AssetUrl} target={v.DocumentType && v.DocumentType.toLowerCase().includes('videos') ? '_blank' : '_self'} className="search-documents-list-item cursor-pointer">
                                                    <div>
                                                        <span className="documents-date">{v.DatePublishedObjectString}  </span>
                                                        <div className="documents-title">{v.Title}</div>
                                                        <div className="documents-text">
                                                            {v.Manufacturer}
                                                        </div>
                                                    </div>
                                                    <div className="document-info">
                                                        {v.DocumentType}
                                                    </div>
                                                </a>
                                            }
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                            <a href={HomePage.makeHomeTabsListRouteURL(CommonHomePageContent.chain_HomeTabList.DCT.param_value) + '&search=' + searchText + '&viewAll=true'}
                                className="text-center mt-auto pb-3">
                                <div className="bs5 btn btn-sm btn-primary">VIEW ALL DOCUMENT RESULtS</div>
                            </a>
                        </> : <NoContent />
                    }

                </>}
        </>
    )
}

export default Documents